export const APP_DEFAULT_LANGUAGE = "EN";
export const APP_DEFAULT_LENGUAGE_ID = -1;
export const APP_DEFAULT_COUNTRY = "ES";
export const APP_DEFAULT_SHOP_ID = 10703;
export const APP_DEFAULT_MARKET_ID = null;
export const APP_DEFAULT_CURRENCY_FORMAT = "#,##0.00 ¤¤";
export const APP_DEFAULT_MARKETS_ISO = ["WE", "EJ"];
export const APP_USA_SHOP_ID = 11719;
export const MAX_HISTORY_ENTRIES = 10;
export const ZARA_PREOWNED = " | Zara Preowned";

export const ROUTE_ZARA_WEB_PATHS = {
  ACCOUNT: "user/account",
  PROFILE: "user/profile",
  CART: "shop/cart",
  CLOSE_CART: "recom/close/cart",
  FAVORITE: "user/wishlist",
  RECOM_CLOSE: "recom/close"
}

export const ROUTE_ZARA_APPS_PATHS = {
  CLOSE_CART: "recom/close/cart",
}

export const ROUTE_PATHS = {
  HOME: "/home",
  ADDRESS_LIST: "/address-list",
  ADDRESS_LIST_SENDER: "/address-list/sender-address",
  RETURN_ADDRESS_LIST__WM: "/return-address-list",
  ADD_ADDRESS: "/add-address",
  MY_ADDRESSES: "/my-addresses",
  SENDER_ADDRESS: "/sender-address",
  PRODUCTS: "/products",
  MY_ITEMS: "/my-items",
  MY_FAVORITES: "/my-favorites",
  MY_PERSONAL_INFO: "/my-personal-info",
  SELLER_PROFILE: "/seller",
  SELL: "/sell",
  DEFAULT_SELL: "/sell-scan",
  SELL_SCAN: "/sell-scan",
  SELL_SEARCH: "/sell-search",
  SELL_SCAN_FORM: "/sell-scan-form",
  SELL_SEARCH_FORM: "/sell-search-form",
  SELL_SCAN_INTRO: "/sell/intro/scan",
  SELL_SEARCH_INTRO: "/sell/intro/search",
  SELL_SCAN_NEW: "/sell/scan",
  SELL_RESULTS_SCAN: "/sell/results/scan",
  SELL_RESULTS_SEARCH: "/sell/results/search",
  SELL_SEARCH_PDP_NEW: "/sell/product-detail/search",
  SELL_SCAN_PDP_NEW: "/sell/product-detail/scan",
  SELL_FORM_NEW: "/sell/new/form",
  SELL_FORM_EDIT: "/sell/edit/form",
  SELL_HISTORY_PDP_SEARCH:"/sell/product-detail/history-search",
  SELL_PDP_INTRO:"/sell/product-detail/history-intro",
  SELL_HISTORY_SEARCH_NEW:"/sell/history/search",
  PRODUCT_DETAIL: "/product-detail",
  PRODUCT_CREATION_CONFIRMATION: "/sell/confirmation",
  SEARCH: "/search",
  SEARCH_IMAGE_CROP: "/search/image-crop",
  PRODUCT_SEARCH: "/products-search",
  CART: "/cart",
  CHECKOUT: "/checkout",
  CHECKOUT_SHIPPING: "shipping",
  CHECKOUT_PAYMENT: "payment",
  PROFILE: "/profile",
  BANK_ACCOUNT: "/bank-account",
  MY_SALES: "/my-sales",
  MY_PURCHASES: "/my-purchases",
  PAYMENT_CONFIRMATION: "payment-confirmation",
  PAGE_NOT_FOUND: "/page-not-found",
  HELP: "/help",
  ASK_FOR_DETAILS: "/ask-for-details",
  STATEMENT_DAC7: "/statement-dac7",
  NICKNAME: "/nickname",
  REPORT: "/report",
  REPORT_CONFIRMATION: "/report-confirmation",
  BUNDLE: "/bundle",
  BUNDLE_PRODUCTS: "/bundle/products",
  DROP_DROP: "/drop-drop",
  COMMUNICATION: "/communication",
  COUNTER_OFFER: "/counter-offer",
  MANUAL_BARCODE_SEARCH: "/manual-barcode-search",
  OFFER_PRICE: "/offer-price"
} as const;

export const HELP_CATEGORIES = {
  SELLING: "selling",
  BUYING: "buying",
  CONTACT: "contact",
} as const;

export const HELP_CATEGORIES_ROUTE = {
  SELLING_URL: `${ROUTE_PATHS.HELP}/${HELP_CATEGORIES.SELLING}`,
  BUYING_URL: `${ROUTE_PATHS.HELP}/${HELP_CATEGORIES.BUYING}`,
  CONTACT_URL: `${ROUTE_PATHS.HELP}/${HELP_CATEGORIES.CONTACT}`,
} as const;

export const ZARA_COOKIES_KEYS = {
  USER_TYPE: "user_type",
  USER_ID: "user_id",
  ACCES_TOKEN: "access_token",
  ACCES_TOKEN_EXPIRES: "access_token_expires",
};

export const RESELL_GUEST_CART_CODE = "RESELL_GUEST_CART_CODE";

export const ADDRESS_FLOW_TYPE = {
  SENDER_ADDRESS: "sender-address",
  SHIPPING_ADDRESS: "shipping-address",
  PAYMENT_METHOD_ADDRESS: "payment-method",
  CART_ADDRES: "cart-address",
} as any;

export type AddressFlowType =
  (typeof ADDRESS_FLOW_TYPE)[keyof typeof ADDRESS_FLOW_TYPE];

export const ADDRESS_LIST_FLOW_ROUTE = {
  SENDER_ADDRESS_URL: `${ROUTE_PATHS.ADDRESS_LIST}/${ADDRESS_FLOW_TYPE.SENDER_ADDRESS}`,
  SHIPPING_ADDRESS_URL: `${ROUTE_PATHS.ADDRESS_LIST}/${ADDRESS_FLOW_TYPE.SHIPPING_ADDRESS}`,
  PAYMENT_METHOD_URL: `${ROUTE_PATHS.ADDRESS_LIST}/${ADDRESS_FLOW_TYPE.PAYMENT_METHOD_ADDRESS}`,
  CART_ADDRES_URL: `${ROUTE_PATHS.ADDRESS_LIST}/${ADDRESS_FLOW_TYPE.CART_ADDRES}`,
} as const;

export const ADD_ADDRESS_FLOW_ROUTE = {
  "sender-address": `${ROUTE_PATHS.ADD_ADDRESS}/${ADDRESS_FLOW_TYPE.SENDER_ADDRESS}`,
  "shipping-address": `${ROUTE_PATHS.ADD_ADDRESS}/${ADDRESS_FLOW_TYPE.SHIPPING_ADDRESS}`,
  "payment-method": `${ROUTE_PATHS.ADD_ADDRESS}/${ADDRESS_FLOW_TYPE.PAYMENT_METHOD_ADDRESS}`,
  "cart-address": `${ROUTE_PATHS.ADD_ADDRESS}/${ADDRESS_FLOW_TYPE.CART_ADDRES}`,
} as const;

export const SCROLL_STORAGE_KEY = {
  SEARCH_GRID_SCROLL: "search-grid-scroll",
  MAIN_GRID_SCROLL: "main-grid-scroll",
  BUNDLE_GRID_SCROLL: "bundle-grid-scroll",
  MYITEMS_GRID_SCROLL: "myitems-grid-scroll",
  MYFAVORITES_GRID_SCROLL: "myfavorites-grid-scroll",
  MYSALES_PAGE_SCROLL: "mysales-page-scroll",
  MYPURCHASES_PAGE_SCROLL: "mypurchases-page-scroll",
  SELLERPROFILE_GRID_SCROLL: "sellerprofile-grid-scroll",
  IMAGE_SEARCH_SCROLL: "image-search-scroll",
} as const;

export const SECTION_ABOUT = "preowned-about-mkt5795.html?v1=2317174&regionGroupId=107"